"use client";

import { useEffect } from "react";

import { useAnalytics } from "@/hooks/useAnalytics";
import { FunnelEvent } from "@/types/analytics";

export default function HomePageTracker() {
  const { trackFunnelEvent, trackPageView } = useAnalytics();

  useEffect(() => {
    // Track landing page viewed
    trackFunnelEvent(FunnelEvent.LANDING_PAGE_VIEWED, {
      source: "direct",
      referrer: document.referrer || "none",
    });

    // Track general page view
    trackPageView("home", {
      page_type: "landing",
    });
  }, [trackFunnelEvent, trackPageView]);

  return null;
}
